/**
 * Created by Andrey Popov on 28.04.2025
 */

const QuestsGroupIconView = cc.Node.extend({
    ctor: function (model) {
        this._super();

        this.model = model;

        const styles = cleverapps.styles.QuestsTableView;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(styles.size);

        const bg = cleverapps.UI.createScale9Sprite(bundles.questsgroupicon.frames.quests_scroll_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize2(this.getContentSize());
        bg.setAlignment(this.width / 2, this.height / 2);
        this.addChild(bg, -1);

        this.questsTable = new ScrollTable(Map2dLocation.currentLocation.questsDataSource, {
            scrollDisabled: true,
            parentView: this
        });

        this.scrollTableView = new cleverapps.UI.ScrollView(new cc.Node(), {
            scrollBarEnabled: false,
            mouseScroll: false,
            dock: { toEnd: false }
        });

        this.tableHandler = new TableHandler(this.questsTable, this.scrollTableView, {
            rowConstructor: QuestIcon,
            styles,
            scroll: 0,
            countOfRowsToSnap: 1
        });

        this.scrollTableView.setAlignment(this.width / 2, this.height / 2);
        this.addChild(this.scrollTableView);

        this.model.onGetIconViewListener = this.createListener(this.getIconView.bind(this));
        this.model.onGetView = this.createListener(() => this);
    },

    scrollToItem: function (iconView, callback) {
        callback = callback || function () {};

        let row;
        if (iconView) {
            row = this.questsTable.rows.find((r) => r.id === iconView.id);
        } else {
            row = this.questsTable.rows[0];
        }

        if (!row) {
            callback();
            return;
        }

        this.runAction(new cc.Sequence(
            new cc.CallFunc(() => {
                this.scrollTableView.updateInnerContent();
                this.questsTable.scrollToRow(row.id);
            }),
            new cc.DelayTime(TableHandler.SCROLL_DURATION)
        )).setFinalize(callback);
    },

    getIconView: function (quest) {
        return this.questsTable.getRowView(quest.id);
    }
});

cleverapps.styles.QuestsTableView = {
    size: {
        width: 210,
        height: 720
    },

    margin: 30,

    padding: { x: 20, y: 0 },
    innerPadding: { x: 0, y: 20 }
};